import { fetchApi } from "./fetchApi";

export default {
  async get(id) {
    return fetchApi({
      method: "get",
      url: `/api/dropdown/${id}`,
    });
  },

  async list() {
    const response = await fetchApi({
      method: "get",
      url: "/api/dropdown",
    });
    return response;
  },

  async listFiltered(attributeName) {
    const response = await fetchApi({
      method: "get",
      url: "/api/dropdown",
      params: { attributeName },
    });
    return response;
  },

  async update({ id, label }) {
    const response = await fetchApi({
      data: {
        label,
      },
      method: "put",
      url: `/api/dropdown/${id}`,
    });

    return response.data.result;
  },
};
